import { AfterViewInit, Component, EventEmitter, Inject, Input, LOCALE_ID, Output } from '@angular/core';
import { take, takeUntil } from 'rxjs/operators';
import { combineLatest, of } from 'rxjs';
import { InitialDataService } from 'src/app/services/page/initial-data.service';
import { BasePageComponent } from '../../base-page/base-page.component';
import { CookieService } from 'ngx-cookie-service';
import { ActivatedRoute, Router } from '@angular/router';
import { HOST_NAME } from 'src/app/global.tokens';
import { UntypedFormControl } from '@angular/forms';
import { LoginStatusService } from 'src/app/services/auth/login/login-status.service';
import { LoggedStatus } from 'src/app/services/auth/login/login.models';
import { gameTrx, liveCasinoTrx, loginTrx, referFriendTrx, signUpTrx, slotsLuckeraTrx } from 'src/app/router-translation.labels';
import { TranslationConfig } from 'src/app/utils/translate-config';
import { Language, MenuItem } from 'src/app/apollo/models/base-models';
import { LicenceService } from 'src/app/services/utils/licence.service';
import { DocumentData, documentData, SectionCard, sectionsData, Status, UserDocumentsResponse } from 'src/app/services/profile/upload-documents.models';
import { UploadDocumentsService } from 'src/app/services/profile/upload-documents.service';
import { PendingWithdrawalService } from 'src/app/services/payment/withdrawal/pending-withdrawal.service';
import { PendingWithdrawalList } from 'src/app/services/payment/withdrawal/withdrawal.models';
import { UserMessagesService } from 'src/app/services/user-messages/user-messages.service';
import { PendingRewardsService } from 'src/app/services/prizes/pending-rewards.service';
import { PendingReward } from 'src/app/services/prizes/prizes.models';
import { extractLanguageCode } from 'src/app/utils/language-switch.utils';
import { DetectDeviceService } from 'src/app/services/utils/detect-device.service';
import { InstallPromptService, isAppMenuItem } from 'src/app/services/pwa/install-prompt.service';

@Component({
  selector: 'app-desktop-sidenav',
  templateUrl: './desktop-sidenav.component.html',
  styleUrls: ['./desktop-sidenav.component.scss']
})
export class DesktopSidenavComponent extends BasePageComponent implements AfterViewInit {
  @Output() closeNav = new EventEmitter();
  @Input() toggle: boolean;
  childData: any;
  allMenuItems: any[] = [];
  deferredPrompt: any;
  currentUrl: string;
  languagelist = new UntypedFormControl('');
  isLogin: boolean = false;
  public userDocumentData: SectionCard[];
  hasDocumentRequest: boolean;
  pendingList: PendingWithdrawalList;
  unreadMessages: number = 0;
  pendingRewardsList:PendingReward[]

  _isVisible: boolean = false;

  @Input() set isVisible(value: boolean) {
    this._isVisible = value;
  }

  get isVisible(): boolean {
    return this._isVisible;
  }

  liveCasinoRoute: string = `/${this.translationConfig.getTranslation(liveCasinoTrx)}`;
  slot: string = `/${this.translationConfig.getTranslation(slotsLuckeraTrx)}`;
  selectedLanguage: Language;
  constructor(
    public initialData: InitialDataService,
    private router: Router,
    private cookie: CookieService,
    private activeRoute: ActivatedRoute,
    protected loginStatus: LoginStatusService,
    protected translationConfig: TranslationConfig,
    private documentService: UploadDocumentsService,
    protected licenceService: LicenceService,
    private pendingListService: PendingWithdrawalService,
    @Inject(HOST_NAME) public hostName,
    @Inject(LOCALE_ID) public locale,
    private userMessagesService: UserMessagesService,
    private pendinRewardsService: PendingRewardsService,
    public detectDeviceService: DetectDeviceService,
    private installPromptService: InstallPromptService,
  ) { super(); }

  ngOnInit(): void {
    this.installPromptService.deferredPrompt$.pipe(takeUntil(this.unsubscribe)).subscribe(prompt => {
      this.deferredPrompt = prompt;
      if (this.childData?.topMenuItems) {
        const canInstall = this.detectDeviceService.canShowAppMenu(this.deferredPrompt);
        this.childData = { ...this.childData, topMenuItems: canInstall ? this.allMenuItems : this.filterMenuItems() };
      }
    });

    const set_sidenav = (api_call$) => {
      
      api_call$.pipe(takeUntil(this.unsubscribe)).subscribe(([resp, canRefer]) => {
        const viewData = { ...resp };
        if (!canRefer) {
          const referFriendPath = this.translationConfig.getTranslation(referFriendTrx);
          viewData.topMenuItems = (viewData.topMenuItems as MenuItem[]).filter((item: MenuItem) =>
            !(item.inAppUrl?.toLowerCase() || '').includes(referFriendPath)
          );
        }
        this.allMenuItems = viewData.topMenuItems || [];
        const canInstall = this.detectDeviceService.canShowAppMenu(this.deferredPrompt);
        this.childData = { ...viewData, topMenuItems: canInstall ? this.allMenuItems : this.filterMenuItems() };
        this.selectedLanguage = resp.languages.find(item => {
          const parts = item.name.split("-"); // Specific logic for Luckera locale parsing
          const langCode = parts[parts.length - 1].trim();
          return langCode === this.locale;
        });
      });

    }

    this.loginStatus.getIfUserLogged().pipe(takeUntil(this.unsubscribe)).subscribe(resp => {
      this.isLogin = true;
      if (this.isLogin) {
        this.documentService.updateUserDocuments();
        this.documentService.getUserDocuments().pipe(takeUntil(this.unsubscribe)).subscribe((userDocumentsResponse: UserDocumentsResponse) => {
          if (userDocumentsResponse) {
            this.userDocumentData = this.documentService.fillSectionCards(sectionsData, userDocumentsResponse, this.documentService.getSectionsCookie());
            this.hasDocumentRequest = !!this.userDocumentData.find((item) => !(item.status === this.documentService.translateStatus(Status.Approved) || item.status === this.documentService.translateStatus(Status.NotRequired)) && !item.is_hide);
          }

        });

        setTimeout(() => { // Side Nav count notifications api calls here
          this.pendingWithdrawalCheck();
        }, 0);
        
        set_sidenav(
          combineLatest([
            this.initialData.fetchData(),
            this.loginStatus.canAccessReferFriend()
          ])
        );
        return;
      }
    });
    
    set_sidenav(
      combineLatest([
        this.initialData.fetchData(),
        of([])
      ])
    );

  }

  closeSideNav() {
    this.closeNav.emit('');
  }

  languageHref(item: any): string | null {
    return item?.redirectUrl ? item.redirectUrl : null;
  }

  onLanguageClick(event: MouseEvent, item: any): void {
    if (item?.redirectUrl) {
      event.preventDefault();
      window.location.href = item.redirectUrl;
    }
  }

  setCookie($event: any) {
    const langCode = extractLanguageCode($event?.value);
    if (!langCode) {
      return;
    }
    this.cookie.set('language', langCode, 2592000, '/', this.hostName);
    const selected = this.childData?.languages?.find((item) => item?.name === $event?.value);
    if (selected?.redirectUrl) {
      window.location.href = selected.redirectUrl;
    }
  }

  signup() {
    this.router.navigate(['', this.translationConfig.getTranslation(signUpTrx)]);
    this.closeSideNav();
  }
  login() {
    this.router.navigate(['', this.translationConfig.getTranslation(loginTrx)], { state: { redirectTo: this.router.url } });
    this.closeSideNav();
  }

  pendingWithdrawalCheck() {
    if (this.isLogin) {
      this.pendingListService.getList().subscribe();
      this.pendingListService.pendingWithdrawalsCount$.pipe(takeUntil(this.unsubscribe)).subscribe({
        next: (resp) => {
          this.pendingList = resp;
        },
        error: (error) => {
          console.log(error)
        }
      });
      this.userMessagesService.unreadMessagesCount.pipe(takeUntil(this.unsubscribe)).subscribe((unreadCount) => {
        this.unreadMessages = unreadCount;
      });
      this.pendinRewardsService.getPendingRewards().pipe(takeUntil(this.unsubscribe)).subscribe((resp) => {
        this.pendingRewardsList = resp;
      });
    }
  }

  ngAfterViewInit() {
    // Side Nav count notifications api calls here
    this.pendingWithdrawalCheck();
  }

  // app menu item is visible only when the browser offers install (deferredPrompt), i.e. app not installed yet
  // safari never fires beforeinstallprompt, so it is shown there unless opened as the installed app
  filterMenuItems(): any[] {
    return this.allMenuItems.filter(menu => !isAppMenuItem(menu));
  }

}
